export default{
  isResponsive:true,
  label:'align',
  prefix:'text',
  steps:['left', 'center', 'right']
}



// WEBPACK FOOTER //
// ./src/shell/schemas/general/text/align.js